module.exports = __webpack_public_path__ + "img/size9.69c1fa86.png";